import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleDrawer } from '@data/state/action/root'
import { DRAWER_TYPES, strings } from '@constants'
import { Calendar, Input, Select } from '@base'
import { createNewEnquiry, createNewEnquiryFromData, fetchBrands, fetchCategories } from './SPOForm/state/actions'
import { AddItemButton, SPOFormButtonWapper, SPOFormContainer } from '../style'

const SPOFormWapper = ({
	state,
	state2,
	valueChangeHandler,
	dispatch,
	edit,
	data = null,
	_suppliers,
	selectedSupplier,
	userChangeHandler,
	addNewItemToEnquiryCallback,
	deleteEnquiryItemCallback,
	updateEnquiryItemCallback,
	updateplatformcallback,
}) => {
	const globalDispatch = useDispatch()
	const user = useSelector((state) => state.getIn(['user', 'user']))
	const commodityFilter = user?.commodity?.find((item) => item?.active)

	const getState = () => state

	useEffect(() => {
		if (edit && data) {
			dispatch(createNewEnquiryFromData(data))
		} else {
			dispatch(createNewEnquiry(user))
		}
		dispatch(fetchCategories(commodityFilter?.commodity_name))
		dispatch(fetchBrands())

		return () => {
			// dispatch(clearNewEnquiryState())
		}
	}, [commodityFilter])

	const addNewItemButtonClick = (categoryId = null) => {
		globalDispatch(
			toggleDrawer(true, DRAWER_TYPES.ADD_NEW_SPO_ITEM, {
				getState,
				defualtCategoryId: categoryId,
				addNewItemToEnquiryCallback,
				deleteEnquiryItemCallback,
				updateEnquiryItemCallback,
				updateplatformcallback,
				dispatch: dispatch,
				activeCommodity: false,
			})
		)
	}

	return (
		<SPOFormContainer>
			<SPOFormButtonWapper>
				<Select
					id='admin-buyer-supplier'
					placeholder={strings('placeholder_select_supplier')}
					data={_suppliers}
					displayKey='display_name'
					primaryKey='user_id'
					value={selectedSupplier ?? {}}
					onChange={(e) => {
						userChangeHandler(e)
					}}
					label={strings('select', 'supplier')}
				/>
				<Input
					id='admin-supplier-po-number'
					label={strings(['enter', 'supplier', 'po', 'number'])}
					type='text'
					placeholder={strings(['enter', 'supplier', 'po', 'number'])}
					value={state2?.enquiryQuote?.original_supplier_po_number}
					onChange={valueChangeHandler(null, 'original_supplier_po_number')}
				/>
				<Calendar
					label={strings('po', 'date')}
					value={state2.enquiryQuote?.supplier_po_date}
					onChange={(v) => valueChangeHandler(null, 'supplier_po_date')(v)}
					// position='top'
				/>
			</SPOFormButtonWapper>
			<AddItemButton
				uppercase
				small
				onClick={() => {
					addNewItemButtonClick()
				}}
			>
				{strings('add')}
			</AddItemButton>
		</SPOFormContainer>
	)
}

export default SPOFormWapper
